module.exports = __webpack_public_path__ + "img/new14.1782046d.png";